import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MissionListingConfig, Workspace } from '../models';
import { MyAccountV2Client } from './my-account-v2.client';

const BASE_URL = '/workspaces';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceApi {
  constructor(private _http: MyAccountV2Client) {}

  updateWorkspace(workspaceId: string, workspace: Partial<Workspace>): Observable<Workspace> {
    return this._http.patch<Workspace>(`${BASE_URL}/${workspaceId}`, workspace);
  }

  getWorkspace(workspaceId: string): Observable<Workspace> {
    return this._http.get<Workspace>(`${BASE_URL}/${workspaceId}`);
  }

  getMissionListingConfig(): Observable<Partial<MissionListingConfig>[]> {
    return this._http.get<Partial<MissionListingConfig>[]>(`/workspaces-filter-settings`);
  }

  updateMissionListingConfig(id: string, isEnabled: boolean) {
    return this._http.patch<Workspace>(`/workspaces-filter-settings/${id}/toggle-status`, { isEnabled });
  }
}
